<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row class="details">
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col class="pb-2">
                            <b-button variant="primary" @click="pdfExport" class="mr-2 float-right">
                            {{  $t('globalTrans.export_pdf') }}
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row v-if="!dataLoaded">
                      <h3 class="m-auto mb-3">Loading...</h3>
                    </b-row>
                    <b-row v-if="dataLoaded">
                          <b-col md=12>
                              <b-table-simple striped bordered small hover>
                                  <tbody>
                                      <b-tr>
                                          <b-td>{{ $t('globalTrans.organization') }}</b-td>
                                          <b-td colspan="3">{{ getOrgName(profile.org_id) }}</b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>{{ $t('child_configuration.institute_type') }}</b-td>
                                          <b-td colspan="3">{{ getInstituteType(profile.office_type_id) }}</b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>{{ $t('child_configuration.institute_name') }}</b-td>
                                          <b-td colspan="3">{{ (currentLocale === 'en') ? profile.institute_name : profile.institute_name_bn }}</b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>{{ $t('ds_student_management.date') }}</b-td>
                                          <b-td>{{ profile.date | dateFormat }}</b-td>
                                          <b-td>{{ $t('globalTrans.mobile_no') }}</b-td>
                                          <b-td>{{ profile.student.mobile_no | mobileNumber }}</b-td>
                                      </b-tr>
                                        <b-tr>
                                          <b-td>{{ $t('ds_student_management.student_roll') }}</b-td>
                                          <b-td>{{ $n(profile.student.student_id, { useGrouping: false }) }}</b-td>
                                          <b-td>{{ $t('ds_institute_management.class') }}</b-td>
                                          <b-td>{{ getClassList(profile.student.class_id) }}</b-td>
                                      </b-tr>
                                      <b-tr>
                                          <b-td>{{ $t('ds_student_management.student_name') }}</b-td>
                                          <b-td colspan="3">{{ (currentLocale === 'en') ? profile.student.name_en : profile.student.name_bn }}</b-td>
                                      </b-tr>
                                      <b-tr v-if="profile.therapy_center_id">
                                          <b-td>{{ $t('ds_config.therapy_center') }}</b-td>
                                          <b-td colspan="3">{{ profile.therapy_center_name }}</b-td>
                                      </b-tr>
                                      <b-tr v-else>
                                          <b-td>{{ $t('ds_config.therapy_center') + ' (' + $t('ds_student_management.other_center') + ')' }}</b-td>
                                          <b-td colspan="3">{{ (currentLocale === 'en') ? profile.other_center_en : profile.other_center_bn }}</b-td>
                                      </b-tr>
                                        <b-tr>
                                          <b-td>{{ $t('ds_institute_management.remarks') }}</b-td>
                                          <b-td colspan="3">{{ (currentLocale === 'en') ? profile.remarks : profile.remarks_bn }}</b-td>
                                      </b-tr>
                                  </tbody>
                              </b-table-simple>
                          </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { getTherapyByOfficeApi } from '../../api/routes'
import ExportPdf from './export-pdf_details'

export default {
  props: ['id'],
  components: {
  },
  data () {
    return {
      profile: {},
      dataLoaded: false
    }
  },
  created () {
    if (this.id) {
        const tmp = this.getStudentTherapyManagement()
        this.profile = tmp
        if (this.profile.therapy_center_id) {
          this.getTherapyCenterList(this.profile.therapy_center_id)
        } else {
          this.dataLoaded = true
        }
    }
  },
  mounted () {
    core.index()
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    getTherapyCenterList (Id) {
          const data = {
              org_id: this.profile.org_id,
              office_type_id: this.profile.office_type_id,
              office_id: this.profile.office_id
          }
          RestApi.getData(disabilitySchoolServiceBaseUrl, getTherapyByOfficeApi, data).then(response => {
            if (response.success) {
                const Obj = response.data.find(el => el.value === parseInt(Id))
                if (this.$i18n.locale === 'bn') {
                  this.profile.therapy_center_name = Obj.text_bn
                } else {
                  this.profile.therapy_center_name = Obj.text_en
                }
                this.dataLoaded = true
            } else {
            }
          })
    },
    getOrgName (orgId) {
        const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getInstituteType (Id) {
        const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
     getClassList (typeId) {
        const Type = this.$store.state.DisabilitySchoolService.commonObj.classList.find(type => type.value === typeId)
        if (this.$i18n.locale === 'bn') {
            return Type.text_bn
        } else {
            return Type.text_en
        }
    },
    getStudentTherapyManagement () {
        const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
        return JSON.parse(JSON.stringify(tmpData))
    },
      pdfExport () {
      const reportTitle = this.$t('ds_student_management.student_therapys') + ' ' + this.$t('globalTrans.details') + ' ' + this.$t('sidebar.information')
      ExportPdf.exportPdfDetails(disabilitySchoolServiceBaseUrl, 'configuration/report-heading/detail', this.profile.org_id, reportTitle, this.profile, this)
    }
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .mytd{
        padding: 0.45rem 0.75rem 0.45rem 0.75rem !important;
    }
</style>
